import moment from "moment";
import { ISubTransaction, ISubTransactionOutput } from "../components/Transactions/Components/Form/Fields/Details/Fields/SubTransactions/SubTransactionsField";

export const toForm = (purchasedAt: moment.Moment, input?: ISubTransaction): ISubTransaction => {
    if (!input) {
        return {
            date: purchasedAt,
            amount: '',
            description: '',
        } as any;
    }

    input.date = moment(input.date);
    return input;
};

export const toExport = (value: ISubTransaction): ISubTransactionOutput => {
    return {
        amount: value.amount,
        date: moment(value.date).format('YYYY-MM-DD'),
        description: value.description,
    };
};
